import React from "react";
import {Div, Img} from "glamorous";
import PropTypes from "prop-types";
import data from "../../data";
import styles from "../../styles";
import icons from "../../imgs/icons";
import {track} from "../../misc/utils";

import TemplateOption from './Background/TemplateOption';
import Heading from '../common/Heading';
import List from './Background/List';
import {ContentContainer, PageContainer} from "./Background/Styles";
import templates from '../../data/background-templates';

const e = styles.editor;
const s = styles.background;

class SelectBackground extends React.Component {

    state = {
        template: null,
        availableBackgrounds: []
    };

    componentWillMount() {
        let availableTemplates = templates.filter(
            template =>
                template.productIds === undefined ||
                template.productIds.length === 0 ||
                template.productIds.includes(this.props.productId)
        );

        this.setState({
            availableTemplates,
            template: availableTemplates[0]
        });
    }

    setTemplate(template) {
        this.setState({
            template: template
        })
    }

    render() {
        const {productId} = this.props;
        const {availableTemplates} = this.state;

        return (
            <PageContainer>
                <Heading>{data.copy("selectBackgroundHeading")}</Heading>
                <Div css={s.preview}>
                    <Img src={this.state.template.preview} css={s.selected}/>
                    <Img css={e.cutLineLeft} src={icons.cutLine}/>
                    <Img css={e.cutLineRight} src={icons.cutLine}/>
                </Div>

                <ContentContainer>
                    <List>
                        {availableTemplates.map((template, index) => (
                            <TemplateOption
                                key={`template_option_${index}`}
                                template={template}
                                isSelected={template === this.state.template}
                                handleClick={() => {
                                    track.event('button', 'choose_template', `${productId}_template_${index}`);
                                    this.setTemplate(template);
                                }}
                            />
                        ))}
                    </List>
                    <Div display="flex" justifyContent="center">
                        <Div
                            onClick={() => {
                                track.event("button", "click", "Continue");
                                this.props.setTemplate(this.state.template);
                            }}
                            css={styles.ctas.continueBtn}
                        >
                            {data.copy("continueBtn")}
                        </Div>
                    </Div>
                </ContentContainer>
            </PageContainer>
        );
    }
}

SelectBackground.propTypes = {
    productId: PropTypes.string.isRequired,
    setArea: PropTypes.func.isRequired,
    setTemplate: PropTypes.func.isRequired
};

export default SelectBackground;



// WEBPACK FOOTER //
// ./src/components/areas/SelectBackground.js